export const idlFactory = ({ IDL }) => {
  const MintRequestLegacy = IDL.Tuple(IDL.Principal, IDL.Nat64)
  const Result_2 = IDL.Variant({ ok: IDL.Text, err: IDL.Text })
  const BroadcastedUtxo = IDL.Record({
    owner: IDL.Text,
    utxoid: IDL.Text,
  })
  const OutPoint = IDL.Record({
    txid: IDL.Vec(IDL.Nat8),
    vout: IDL.Nat32,
  })
  const Utxo = IDL.Record({
    height: IDL.Nat32,
    value: IDL.Nat64,
    outpoint: OutPoint,
  })
  const UtxoStatus = IDL.Variant({
    ValueTooSmall: Utxo,
    Tainted: Utxo,
    Minted: IDL.Record({
      minted_amount: IDL.Nat64,
      block_index: IDL.Nat64,
      utxo: Utxo,
    }),
    Checked: Utxo,
  })
  const PendingUtxo = IDL.Record({
    confirmations: IDL.Nat32,
    value: IDL.Nat64,
    outpoint: OutPoint,
  })
  const UpdateBalanceError = IDL.Variant({
    GenericError: IDL.Record({
      error_message: IDL.Text,
      error_code: IDL.Nat64,
    }),
    TemporarilyUnavailable: IDL.Text,
    AlreadyProcessing: IDL.Null,
    NoNewUtxos: IDL.Record({
      required_confirmations: IDL.Nat32,
      pending_utxos: IDL.Opt(IDL.Vec(PendingUtxo)),
      current_confirmations: IDL.Opt(IDL.Nat32),
    }),
  })
  const UpdateBalanceResult = IDL.Variant({
    Ok: IDL.Vec(UtxoStatus),
    Err: UpdateBalanceError,
  })
  const Result_1 = IDL.Variant({
    ok: UpdateBalanceResult,
    err: IDL.Text,
  })
  const ProcessedUtxo = IDL.Record({
    status: IDL.Text,
    value: IDL.Nat64,
    owner: IDL.Principal,
    completed: IDL.Bool,
    minted: IDL.Bool,
    blockheight: IDL.Nat,
  })
  const Subaccount = IDL.Vec(IDL.Nat8)
  const Result = IDL.Variant({ ok: IDL.Nat, err: IDL.Text })
  const VoltTransferRequest = IDL.Record({
    id: IDL.Opt(IDL.Nat),
    to: IDL.Text,
    fee: IDL.Opt(IDL.Nat),
    notify: IDL.Opt(IDL.Bool),
    other: IDL.Opt(IDL.Vec(IDL.Nat8)),
    memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
    canister: IDL.Text,
    amount: IDL.Nat,
    standard: IDL.Text,
  })
  const VoltAuthorization = IDL.Record({
    request: VoltTransferRequest,
    user: IDL.Principal,
    binding: IDL.Bool,
    expiry: IDL.Int,
    receiver: IDL.Principal,
  })
  const Protocol = IDL.Variant({
    btc: IDL.Null,
    ckbtc: IDL.Null,
    volt: IDL.Null,
  })
  return IDL.Service({
    add_fastbtc_bulk: IDL.Func(
      [IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat64, IDL.Text))],
      [],
      []
    ),
    add_fastbtc_bulk_proxy: IDL.Func([IDL.Vec(MintRequestLegacy)], [], []),
    add_fastbtc_proxy: IDL.Func([MintRequestLegacy], [], []),
    admin_broadcast: IDL.Func([IDL.Text, IDL.Vec(IDL.Text)], [], []),
    admin_broadcast_ckbtc: IDL.Func([IDL.Text, IDL.Text, IDL.Nat64, IDL.Text], [Result_2], []),
    admin_broadcast_utxo: IDL.Func([IDL.Text, BroadcastedUtxo], [Result_2], []),
    admin_broadcast_utxo_v2: IDL.Func([IDL.Text, BroadcastedUtxo, IDL.Nat64], [Result_2], []),
    admin_claim: IDL.Func([IDL.Text, IDL.Vec(IDL.Text)], [], []),
    admin_manual_process: IDL.Func([IDL.Text, IDL.Text], [Result_1], []),
    checkUtxo: IDL.Func([IDL.Text], [IDL.Opt(ProcessedUtxo)], ['query']),
    ckbtc_deposit: IDL.Func([IDL.Opt(Subaccount), IDL.Nat], [Result], []),
    console_log: IDL.Func([IDL.Nat], [IDL.Vec(IDL.Text)], ['query']),
    fixUtxos: IDL.Func([IDL.Text, IDL.Text, IDL.Text], [], []),
    icrc10_supported_standards: IDL.Func(
      [],
      [IDL.Vec(IDL.Record({ url: IDL.Text, name: IDL.Text }))],
      ['query']
    ),
    icrc28_trusted_origins: IDL.Func(
      [],
      [IDL.Record({ trusted_origins: IDL.Vec(IDL.Text) })],
      ['query']
    ),
    minter_balance_update: IDL.Func([IDL.Text], [], []),
    proxy_canisters: IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    stats: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))], ['query']),
    test: IDL.Func([IDL.Text], [], []),
    volt_authorization_notification: IDL.Func(
      [IDL.Nat, VoltAuthorization, IDL.Opt(IDL.Vec(IDL.Nat8))],
      [
        IDL.Record({
          keep: IDL.Opt(IDL.Bool),
          amount: IDL.Opt(IDL.Nat),
          forward: IDL.Opt(IDL.Text),
        }),
      ],
      []
    ),
    withdraw: IDL.Func([IDL.Text, IDL.Text, IDL.Nat, Protocol], [Result], []),
  })
}
export const init = ({ IDL }) => {
  return []
}
